<template>
  
          <v-container fluid class="unauthorized d-flex flex-column align-center justify-center">
    <v-card class="elevation-12 pa-8 text-center rounded-xl" max-width="600">
      <!-- İllüstrasyon -->
      <div class="mb-6">
        <img src="@/assets/unauthorized.png" alt="Unauthorized" class="illustration" />
      </div>

      <!-- Başlık + Açıklama -->
      <h1 class="text-h5 font-weight-bold red--text mb-3">Erişim Reddedildi</h1>
      <p class="grey--text text-subtitle-1 mb-6">
        Bu sayfaya erişim izniniz bulunmamaktadır.<br />
        Lütfen yetkili bir kullanıcı hesabı ile giriş yapın.
      </p>

      <!-- Butonlar -->
      <!-- <v-card-actions class="justify-center">
        <v-btn color="primary" dark large class="px-6 rounded-pill" @click="$router.push('/')">
          <v-icon left>mdi-home</v-icon>
          Ana Sayfa
        </v-btn>
        <v-btn color="red darken-1" text large class="px-6 rounded-pill" @click="anasayfa()">
          <v-icon left>mdi-login</v-icon>
          Tekrar Giriş Yap
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-container>


</template>

<script>
import router from '@/router';

export default {
  name: "UnAuthorized",
methods:{
  anasayfa(){
    console.log("anasayfa",this.$route.params.id);
    
//  router.push({ name: 'KullaniciLogin', params: { id: result.data.formId }})
  },
}
};
</script>

<style scoped>
.unauthorized {
  min-height: 100vh;
  background: linear-gradient(135deg, #f6f9fc, #e9ecef);
}

.illustration {
  max-width: 280px;
  width: 100%;
}

.v-card {
  border-radius: 20px;
}
</style>
